import type { ConfigIdT } from '@mentimeter/http-clients';
import type { ComponentType } from 'react';
import { ColorJoyBackground } from './colorjoy';
import { ExploreBackground } from './explore';
import { GradientBackground } from './gradient';
import { GreenhouseBackground } from './greenhouse';
import { NatureBackground } from './nature';
import { NeuralNetworksBackground } from './neural-networks';
import { SpaceBackground } from './space';
import { WavesBackground } from './waves';
import { WavesBlueBackground } from './waves-blue';
import { WavesPurpleBackground } from './waves-purple';

export const legacyThemeAnimatedBackgroundsMap: Partial<
  Record<Partial<ConfigIdT>, ComponentType>
> = {
  greenhouse: GreenhouseBackground,
  nature: NatureBackground,
  gradient: GradientBackground,
  space: SpaceBackground,
  colorjoy: ColorJoyBackground,
  waves: WavesBackground,
  'waves-blue': WavesBlueBackground,
  'waves-purple': WavesPurpleBackground,
  explore: ExploreBackground,
  'particle-blue': NeuralNetworksBackground,
};
